/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignNameAvailabilityResponseSchema } from '../campaign-schema';

export const checkCampaignNameAvailabilityPathSchema = z.object({
  workspaceId: z.string(),
});

export const checkCampaignNameAvailabilityQuerySchema = z.object({
  name: z.string(),
});

export const checkCampaignNameAvailabilityOperationResponseSchema =
  campaignNameAvailabilityResponseSchema;

export type CheckCampaignNameAvailabilityInput = {
  path: z.input<typeof checkCampaignNameAvailabilityPathSchema>;
  query?: z.input<typeof checkCampaignNameAvailabilityQuerySchema>;
  signal?: AbortSignal;
};

export async function checkCampaignNameAvailability({
  path,
  query,
  signal,
}: CheckCampaignNameAvailabilityInput): Promise<
  z.infer<typeof checkCampaignNameAvailabilityOperationResponseSchema>
> {
  const parsedPath = checkCampaignNameAvailabilityPathSchema.parse(path);
  const parsedQuery = checkCampaignNameAvailabilityQuerySchema.parse(
    query ?? {},
  );

  const response = await socialApiClient.get(
    `workspaces/${parsedPath.workspaceId}/campaigns/name/availability`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return checkCampaignNameAvailabilityOperationResponseSchema.parse(
    await response.json(),
  );
}
